import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=124775e4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\刘正希\\Desktop\\知谦\\zq\\webside\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-124775e4"]])

export default __exports__